/**
 * Created by linjianxi on 2016/10/25.
 */
import * as actions from './actions'
import * as getters from './getter'
import { GET_REFLECT_LIST } from './mutation-type'

const state = {
  price: 2121,
  gridData: {}
}
const mutations = {
  [GET_REFLECT_LIST] (state, data) {
    state.gridData = data
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/reflect/store.js